import _ from 'lodash';
import {combineReducers} from 'redux';
import {default as listReducer} from './list';
import {default as detailReducer} from './detail';

import {formatDate} from 'utils/datetime';

export const getUserNationality = user => ({
  value: _.get(user, 'nationality.code'),
  label: _.get(user, 'nationality.name')
});

export const getUserBirthday = user =>
  user.birthday ? formatDate(user.birthday) : user.birthday;

const reducer = combineReducers({
  list: listReducer,
  detail: detailReducer
});

export default reducer;
export * from './list';
export * from './detail';
